export const ADD_PAGE_STARTED = 'ADD_PAGE_STARTED';
export const ADD_PAGE_COMPLETED = 'ADD_PAGE_COMPLETED';
export const ADD_PAGE_ERROR = 'ADD_PAGE_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/pageActionTypes.js